{
  "name": "player",
  "version": "7.31.3",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 8081 --configuration development",
    "start:local": "ng serve --port 8081 --configuration local",
    "dev": "node --run start",
    "prodloc": "ng serve --port 8081 --configuration production",
    "build": "ng build && npm run gVersion && pnpm sentry:sourcemaps",
    "build:development": "ng build --configuration=development && npm run gVersion && pnpm sentry:sourcemaps",
    "build:production": "ng build --configuration=production && npm run gVersion && pnpm sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "cross-env BROWSERSLIST_ENV=test ng test",
    "test:e2e": "playwright test",
    "lint": "pnpm exec oxlint --config ../../.oxlintrc.json --vitest-plugin src test playwright.config.ts",
    "gVersion": "node generateVersion.js",
    "serve": "serve -s dist/player/browser",
    "sentry:sourcemaps": "node ./scripts/upload-sentry-sourcemaps.mjs"
  },
  "dependencies": {
    "@admefy/domain": "workspace:*",
    "@angular/animations": "22.2.0",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/platform-browser": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@angular/router": "22.2.3",
    "@angular/service-worker": "22.2.3",
    "@jsverse/transloco": "8.4.0",
    "@ng-web-apis/common": "5.4.0",
    "@ngrx/operators": "22.0.1",
    "@ngrx/signals": "22.0.1",
    "@sentry/angular": "10.76.2",
    "@sentry/cli": "3.8.1",
    "animate.css": "4.1.1",
    "centrifuge": "5.8.0",
    "core-js": "3.51.0",
    "dayjs": "^1.11.23",
    "hls.js": "1.7.3",
    "markdown-it": "^15.0.3",
    "ng-otp-input": "2.0.10",
    "ngxtension": "7.3.1",
    "plyr": "3.8.4",
    "random-gradient": "0.0.2",
    "randomcolor": "0.6.2",
    "rxjs": "7.8.2",
    "scheduler-polyfill": "1.3.0",
    "semver": "7.8.5",
    "socket.io-client": "4.8.4",
    "tslib": "2.8.1",
    "twemoji": "14.0.2",
    "wavesurfer.js": "7.12.12"
  },
  "devDependencies": {
    "@angular/build": "22.2.3",
    "@angular/cli": "22.2.3",
    "@angular/compiler-cli": "22.2.3",
    "@playwright/test": "1.64.1",
    "@tailwindcss/postcss": "4.3.3",
    "@tailwindcss/typography": "^0.5.20",
    "@types/markdown-it": "^14.2.0",
    "@types/random-gradient": "0.0.2",
    "@types/randomcolor": "0.5.9",
    "@types/semver": "7.8.0",
    "autoprefixer": "10.6.1",
    "browserslist": "4.29.4",
    "cross-env": "10.1.0",
    "ctix": "2.8.2",
    "jsdom": "^30.1.3",
    "postcss": "8.5.31",
    "prettier": "3.9.10",
    "serve": "14.2.6",
    "tailwindcss": "4.3.3",
    "typescript": "6.0.3",
    "vitest": "^4.1.11",
    "zone.js": "0.16.3"
  }
}
